"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var AppStoreLogo_1 = __importDefault(require("../AppStoreLogo"));
var FFQRCode_1 = __importDefault(require("../FFQRCode"));
var PlayStoreLogo_1 = __importDefault(require("../PlayStoreLogo"));
var Text_1 = __importDefault(require("../Text"));
var Box_1 = __importDefault(require("../Box"));
var AppLink_1 = __importDefault(require("../AppLink"));
var AppButton_1 = __importDefault(require("../AppButton"));
var isiOS_1 = require("../utils/isiOS");
var Container = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '50px'
        },
        _b[theme.mediaQueries.sm] = {
            marginTop: '70px',
        },
        _b[theme.mediaQueries.md] = {
            marginTop: '30px',
            flexDirection: 'row',
        },
        _b);
});
var DownloadQRCode = (0, styled_1.default)(FFQRCode_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'none'
        },
        _b[theme.mediaQueries.sm] = {
            display: 'block'
        },
        _b);
});
var AppStores = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'none'
        },
        _b[theme.mediaQueries.sm] = {
            display: 'flex',
            flexDirection: 'column',
        },
        _b[theme.mediaQueries.lg] = {
            flexDirection: 'row',
        },
        _b);
});
var DownloadButton = (0, styled_1.default)(AppButton_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            marginBottom: '16px',
            minHeight: '53px',
            padding: '10px'
        },
        _b[theme.mediaQueries.sm] = {
            display: 'none',
        },
        _b);
});
var DownloadText = (0, styled_1.default)(Text_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            maxWidth: '280px'
        },
        _b[theme.mediaQueries.minWidth('516px')] = {
            maxWidth: 'unset',
        },
        _b);
});
var isIOS = (0, isiOS_1.isiOS)();
function AppDownload(props) {
    var url = props.url, title = props.title, appButtonText = props.appButtonText, iosStoreLink = props.iosStoreLink, iosAppLink = props.iosAppLink, iosImage = props.iosImage, androidStoreLink = props.androidStoreLink, androidAppLink = props.androidAppLink, androidImage = props.androidImage, androidApkLink = props.androidApkLink, footerRegion = props.footerRegion;
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(DownloadQRCode, { size: 132, url: url }),
        react_1.default.createElement(Box_1.default, { ml: { _: 0, md: 3 }, mt: { _: 3, md: 0 } },
            react_1.default.createElement(DownloadText, { mb: { _: "24px", lg: "17px", md: "11px", sm: "11px" }, fontSize: 20, letterSpacing: 2, minWidth: 194 }, title),
            react_1.default.createElement(AppStores, null,
                iosImage ? (react_1.default.createElement(AppLink_1.default, { storeLink: iosStoreLink, appLink: iosAppLink, src: iosImage })) : (react_1.default.createElement(AppStoreLogo_1.default, { storeLink: iosStoreLink, appLink: iosAppLink, region: footerRegion, width: "120px", height: "40px" })),
                androidImage ? (react_1.default.createElement(AppLink_1.default, { storeLink: androidStoreLink, appLink: androidAppLink, src: androidImage, ml: { _: "0px", lg: "5px" }, mt: { _: "11px", lg: "0px" } })) : (react_1.default.createElement(PlayStoreLogo_1.default, { storeLink: androidStoreLink, appLink: androidAppLink, region: footerRegion, width: "135px", height: "40px", ml: { _: "0px", lg: "5px" }, mt: { _: "11px", lg: "0px" } }))),
            react_1.default.createElement(DownloadButton, { appLink: isIOS ? iosAppLink : androidAppLink, storeLink: isIOS
                    ? iosStoreLink
                    : footerRegion === "US"
                        ? androidStoreLink
                        : androidApkLink, variant: "primary", fullWidth: true }, appButtonText))));
}
exports.default = AppDownload;
